import { daysWord } from './format';

/**
 * Contract-fulfilment term in days, read from the harvested `procedure` blob.
 *
 * Two sources publish it under different keys, both meaning "how long the winner
 * has to fulfil the contract" (distinct from the submission deadline):
 *   - etender-uzex → `procedure.deliveryTermDays` (delivery period)
 *   - tender-mc    → `procedure.workDays` (works-completion period)
 * A tender carries at most one, so they collapse to a single «Срок выполнения
 * обязательств» row. Values are numbers (occasionally numeric strings from JSON);
 * anything non-positive or non-numeric yields null so the row is simply omitted.
 */
export function obligationTermDays(
  proc: Record<string, unknown> | null | undefined,
): number | null {
  if (!proc) return null;
  const raw = proc.deliveryTermDays ?? proc.workDays;
  const n =
    typeof raw === 'number'
      ? raw
      : typeof raw === 'string' && /^\d+$/.test(raw.trim())
        ? Number(raw.trim())
        : NaN;
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** "7 дней" / "80 kun", or null when there is no usable term. */
export function formatObligationTerm(
  proc: Record<string, unknown> | null | undefined,
  locale: string,
): string | null {
  const n = obligationTermDays(proc);
  return n == null ? null : `${n} ${daysWord(n, locale)}`;
}
